<div class="create-artist-page-popup__popup">
  <div class="row">
    <div class="create-artist-page-popup__row-text">
      <div class="grid align-items-center flex-column justify-content-center text-center">
        <span class="pi pi-user"></span>
        <p class="mt-4 mb-4">
          Создайте страницу исполнителя, чтобы другие участники могли вас найти и связаться с вами.
        </p>
      </div>
    </div>

    <div class="create-artist-page-popup__row-links">
      <button
        class="ui-buttons ui-buttons__blue-large"
        (click)="onCreateArtistPage($event)"
        pRipple
      >
        Создать страницу исполнителя
      </button>
      <button
        class="ui-buttons ui-buttons__gray-large mt-2"
        (click)="onCloseDialog()"
        pRipple
      >
        Закрыть
      </button>
    </div>
  </div>
</div>
